import sponser1 from "../../assets/client-1.png";
import sponser2 from "../../assets/client-2.png";
import sponser3 from "../../assets/client-3.png";
import sponser4 from "../../assets/client-4.png";
import sponser5 from "../../assets/client-5.png";
import sponser6 from "../../assets/client-6.png";
import sponser7 from "../../assets/client-7.png";
import sponser8 from "../../assets/client-8.png";
import sponser9 from "../../assets/client-9.png";

export const paragraphs = [
  "Hidratantes",
  "Desodorante",
  "Rosa Mosqueta",
  "Vitamina C",
  "Rosa Mosqueta",
  "Proteção Solar",
  "Acne",
  "Dermopés",


];
export const cards = [
  {
    title: "Agora também no canal Farma!",
    text: "Com mais de 34 anos de mercado, somos referência em beleza e autocuidado, oferecendo produtos de extrema qualidade.",
    img: sponser7,
  },
  {
    title: "Somos referência",
    text: "Líder no Centro-Oeste e uma das maiores marcas de vendas por catálogo do Brasil, em 2021 expandimos para o canal Farma, trazendo ainda mais confiança aos consumidores.",
    img: sponser8,
  },
  {
    title: "Explore nossa linha de produtos",
    text: "com foco em produtos desenvolvidos especialmente para farmácias e drogarias de todo o país.",
    img: sponser9,
  },
];
export const sponsors = [
  sponser1,
  sponser2,
  sponser3,
  sponser4,
  sponser5,
  sponser6,
];
